/* tslint:disable:no-console */

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { LogEntry } from './log-entry.model';
import { LogLevel } from './log-level.enum';

@Injectable()
export class ReactiveLogger {
  private _logObservable: Subject<LogEntry>;

  constructor() {
    this._logObservable = new Subject();
  }

  get log(): Subject<LogEntry> {
    return this._logObservable;
  }

  info(message: any) {
    this.write(LogLevel.Info, message);
  }

  debug(message: any) {
    this.write(LogLevel.Debug, message);
  }

  warn(message: any) {
    this.write(LogLevel.Warn, message);
  }

  error(message: any) {
    this.write(LogLevel.Error, message);
  }

  private write(level: LogLevel, message: string) {
    let logEntry: LogEntry = new LogEntry(level, message);
    this._logObservable.next(logEntry);
    console.log(...logEntry.toConsoleLogEntry());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/logging/logger.service.ts